import {html, LitElement} from 'lit';
import {customElement, property, state} from 'lit/decorators.js';
import {query} from "lit/decorators/query.js";
import {SbkForm} from "@/components/form/form";
import "@/components/ch-feedback/ch-feedback.scss";
import {SbkButton} from "@/components/button/button.ts";
import "@/components/loading-animation/loading-animation"

@customElement('sbk-ch-feedback')
export class SbkChFeedback extends LitElement {

    @property({type: Number, attribute: 'feedback-form-id'})
    feedbackFormId: number = 0;

    @property({attribute: 'feedback-url'})
    feedbackUrl: string = '';

    @property({attribute: 'page-url'})
    pageUrl: string = '';

    @property()
    headline: string = '';

    @property()
    subtitle: string = '';

    @query('form')
    _form!: HTMLFormElement

    @query('sbk-form')
    _sbkForm!: SbkForm;

    @query('.form_wrapper')
    _formWrapper!: HTMLDivElement;

    @query('input[type="hidden"][value="currentPagePlaceholder"]')
    _currentPageUrlInput?: HTMLInputElement;

    @query('sbk-button')
    _submitButton!: SbkButton

    @state()
    _isLoading: boolean = true;

    render() {
        return html`
            <sbk-banner variant="neutral">
                <h2>${this.headline}</h2>
                <p class="heading">${this.subtitle}</p>
                ${this._isLoading ?
                        html`<sbk-loading-animation></sbk-loading-animation>`: ''}
                <div class="form_wrapper">
                </div>
            </sbk-banner>
        `;
    }

    createRenderRoot() {
        return this;
    }

    firstUpdated() {
        fetch(this.feedbackUrl)
            .then((response) => response.text())
            .then((data) => {
                this._formWrapper.innerHTML = data;
                if (this._currentPageUrlInput) {
                    this._currentPageUrlInput.value = this.pageUrl;
                }
                this._isLoading = false;
                this._form.removeEventListener('submit', this._sbkForm._onSubmit)
                this._form.addEventListener('submit', (e: Event) => {
                    e.preventDefault();
                    this._onSubmit(this._formWrapper);
                });
            })
    }

    private _onSubmit(formWrapper: HTMLDivElement) {
        const invalidElements = SbkForm.validate(this._form);
        if (invalidElements.length) {
            const firstInvalidElement = invalidElements[0];
            firstInvalidElement.focus({preventScroll: true});
            firstInvalidElement.scrollIntoView({behavior: 'smooth'});
        } else {
            const url = this._form.action.split("&cHash")[0]
            const formData = new FormData(this._form);
            formData.append(this._submitButton.name ?? '', this._submitButton.value ?? '');
            fetch(url, {
                method: this._form.method,
                body: formData,
            })
                .then((response) => {
                    return response.text()
                })
                .then((data) => {
                    formWrapper.innerHTML = data;
                })
        }
    }
}
